import { useParams } from 'react-router-dom';
import { DemandDetailContent } from '../components/DemandDetailContent';

export const DemandDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  if (id == null) return null;
  return <DemandDetailContent id={id} />;
};
